export class BlogGrid extends HTMLElement {
    constructor() {
        super();

        this.bindEvents();
    }

    bindEvents() {
        const viewMoreButton = this.querySelector(".blog__more");
        viewMoreButton?.addEventListener("click", this.fetchMoreArticles.bind(this));
    }

    unbindEvents() {
        const viewMoreButton = this.querySelector(".blog__more");
        viewMoreButton?.removeEventListener
    }

    fetchMoreArticles(event: Event) {
        const url = this.querySelector(".blog__more span")?.getAttribute("data-url");

        if(url) {
            fetch(url)
            .then((response) => response.text())
            .then(data => {
                if (data) {
                    this.refreshContent(data);
                }
            })
            .catch((err) => {
              
            })
        }
    }

    refreshContent(content: string) {
        const blogGridHTML =  this.getSectionInnerHTML(content, ".blog__articles") as string;
        const articleSection = this.querySelector(".blog__articles");
        articleSection?.insertAdjacentHTML('beforeend', blogGridHTML);

        const seeMoreButtonHTML =  this.getSectionInnerHTML(content, ".blog__more") as string;

        if(seeMoreButtonHTML.includes(`data-url=""`)) {
            this.querySelector(".blog__more")?.classList.add("hide");
        }

        const seeMoreButton = this.querySelector(".blog__more");
        if(seeMoreButtonHTML && seeMoreButton) {
            seeMoreButton.innerHTML = seeMoreButtonHTML;
        }
    }

    getSectionInnerHTML(html: string, selector: string) {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML;
    }
}

customElements.define("blog-grid", BlogGrid);